import {useQuery} from "@tanstack/react-query";
import * as api from "../../api";


export const useTimeseriesQuery = (stationId, attributes={}) => {
    return useQuery({
        queryKey: ['timeseries', 'stations', stationId, attributes],
        queryFn: () => api.Timeseries.getTimeseries(stationId, attributes),
        enabled: stationId !== null && stationId !== undefined,
    });
}

export const useTimeseriesModels1AvalancheCountQuery = (microZoneId) => {
    return useQuery({
        queryKey: ['timeseries', 'microZones', microZoneId, "models1AvalancheCount"],
        queryFn: () => api.Timeseries.getModels1AvalancheCount(microZoneId),
        enabled: microZoneId !== null && microZoneId !== undefined,
    });
}

export const useTimeseriesIncidentsQuery = ({filters={}}) => {
    return useQuery({
        queryKey: ['timeseries', 'incidents', filters],
        queryFn: () => api.Timeseries.getIncidents(filters),
    });
}

export const usePublicTimeseriesIncidentsQuery = ({filters={}}) => {
    return useQuery({
        queryKey: ['public', 'timeseries', 'incidents', filters],
        queryFn: () => api.Public.Timeseries.getIncidents(filters),
    });
}

export const useStationQuery = (stationId, props={}) => {
    return useQuery({
        queryKey: ['stations', stationId],
        queryFn: () => api.Station.getStation(stationId),
        ...props
    });
}